import { SelectOption } from '@/src/components/atom/Select';
import {
  ArrayFilters,
  DefaultFilters,
  ListFilterTypeObject,
  WithOptionsFilterFilters,
} from '@/src/components/organism/Filter/types';

export const communityFilters: (
  communityPostingCategoryOptions: SelectOption[],
) => (
  | DefaultFilters
  | WithOptionsFilterFilters
  | ArrayFilters
)[] = communityPostingCategoryOptions => [
  {
    key: 'id',
    label: 'ID',
    placeholder: 'ID를 입력해주세요',
    type: 'TEXT',
  },
  {
    key: 'communityReportType',
    label: '상태',
    placeholder: '전체',
    options: [
      { label: '전체', value: '' },
      { label: '일반', value: 'common' },
      { label: '신고 접수', value: 'reception' },
      { label: '블라인드', value: 'blind' },
    ],
    type: ListFilterTypeObject.SELECT,
  },
  {
    key: 'title',
    label: '제목',
    placeholder: '제목을 입력해주세요',
  },
  {
    key: 'createdAt',
    label: '작성 일자',
    type: 'DATE_RANGE',
    rangeKeys: ['createdAtFrom', 'createdAtTo'],
  },
  {
    key: 'communityCategoryId',
    label: '카테고리',
    placeholder: '전체',
    options: communityPostingCategoryOptions,
    type: ListFilterTypeObject.SELECT,
  },
  {
    key: 'nick',
    label: '닉네임',
    placeholder: '닉네임을 입력해주세요',
  },
];

export const communityCommentFilters: () => (
  | DefaultFilters
  | WithOptionsFilterFilters
  | ArrayFilters
)[] = () => [
  {
    key: 'id',
    label: 'ID',
    placeholder: 'ID를 입력해주세요',
    type: 'TEXT',
  },
  {
    key: 'communityReportType',
    label: '상태',
    placeholder: '전체',
    options: [
      { label: '전체', value: '' },
      { label: '일반', value: 'common' },
      { label: '신고 접수', value: 'reception' },
      { label: '블라인드', value: 'blind' },
    ],
    type: ListFilterTypeObject.SELECT,
  },
  {
    key: 'nick',
    label: '닉네임',
    placeholder: '닉네임을 입력해주세요',
  },
  {
    key: 'createdAt',
    label: '작성 일자',
    type: 'DATE_RANGE',
    rangeKeys: ['createdAtFrom', 'createdAtTo'],
  },
  {
    key: 'content',
    label: '내용',
    placeholder: '내용을 입력해주세요',
  },
];
